/**
 * Created by mohameds on 21/8/19.
 */
import React from 'react';
import {Table} from 'reactstrap';


const Destinations = ({pageData = {}, settings={}}) => {

    const selectedItemsGroup = {};

    const getTableHeadings = () => {
        const tableHeadings = [];
        pageData.headings && pageData.headings.map((destination, index) => {
            tableHeadings.push(
                <th className="font-weight-bold text-center" key={index}>
                    {destination.category}
                </th>
            )
            let selectedItems = [];
            pageData.destinations && pageData.destinations.filter((item, optInd) => {
                if (item.kpi_planning_category === destination.id) {
                    selectedItems.push(item);
                    return true;
                }
                return false;
            });
            selectedItemsGroup[destination.id] = selectedItems;
        });
        return tableHeadings
    };

    const getTableRow = () => {
        let rows = [];
        for (let row = 0; row < 5; row++) {
            let tds = pageData.headings && pageData.headings.map((col, index) => {
                let selectedItems = selectedItemsGroup[col.id];
                // looking for item selected for the row and col
                let curItem = selectedItems[row];

                return (<td key={index} className="kpi-planning-td">
                    {curItem ? curItem.item : <span>&nbsp;</span>}
                </td>);
            });
            rows.push(<tr key={row}>{tds}</tr>);
        }
        return rows;
    }
    return (
        <React.Fragment>
            <div className="btn btn-lg bg-white font-32 text-blue position-relative body-size mt-3 ">
                <div className="p-1">
                    {pageData && pageData.title && pageData.title.toUpperCase()}
                </div>
            </div>
            <Table striped bordered size="sm" className="mb-0 bg-white" 
                style={{marginTop: "50px"}}
            >
                <thead className="bg-info font-32 text-white h-50">
                    <tr>
                        {getTableHeadings()}
                    </tr>
                </thead>
                <tbody className="font-24">
                    <tr/>
                    {getTableRow()}
                </tbody>
            </Table>
        </React.Fragment>
    )
};
export default Destinations


// WEBPACK FOOTER //
// ./src/components/agencyMonitor/Destinations.js